module.exports = __webpack_public_path__ + "static/img/5-1.cc101141.png";